module.exports = __webpack_public_path__ + "static/media/IconBlockchain.aed22812.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/IconBlockchain.svg
// module id = 318
// module chunks = 0